import { useContext } from "react";
import { ApiAccessContext } from "@repo/contexts";

export const useApiAccess = () => {
  const ctx = useContext(ApiAccessContext);

  if (!ctx)
    throw new Error("useApiAccess must be used within ApiAccessProvider");

  return ctx;
};
